<template>
  <select v-model="selected">
    <option></option>
    <option
      v-for="position of positions"
      :key="position.code"
      :value="position"
    >
      {{ position.name }}
    </option>
  </select>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Position } from '@/store/master/types'

@Component
export default class SelectPositionInput extends Vue {
  @Prop() value?: Position

  private get selected(): Position|null {
    return this.value || null
  }

  private set selected(position: Position|null) {
    this.$emit('input', position)
  }

  private get positions() {
    return this.$store.state.master.positions;
  }

  created() {
    this.$store.dispatch('fetchMasterPositions')
  }
}
</script>

<style scoped>
  select{
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
